
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

export const SampleVideo = () => {
  return (
    <section id="sample" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-navy-800 mb-4">Sample Videos</h2>
          <p className="text-xl text-gray-600">Watch our sample montages to see the quality of our work</p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* First Video */}
          <div className="space-y-4">
            <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
              <iframe
                src="https://drive.google.com/file/d/1ByAO1wQXrYQIhFwvE7rwVWcTR9uAkhow/preview"
                allow="autoplay"
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ border: 'none' }}
              ></iframe>
            </div>
            <div className="text-center">
              <motion.a
                whileHover={{ scale: 1.05 }}
                href="https://drive.google.com/file/d/1ByAO1wQXrYQIhFwvE7rwVWcTR9uAkhow/view"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-navy-600 text-white px-6 py-3 rounded-full text-lg font-semibold hover:bg-navy-700 transition-colors"
              >
                Open in Google Drive
                <ExternalLink className="w-5 h-5" />
              </motion.a>
            </div>
          </div>

          {/* Second Video */}
          <div className="space-y-4">
            <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
              <iframe
                src="https://drive.google.com/file/d/11w-tczJAf8ntcm4BQwQoYinCng0R7EFF/preview"
                allow="autoplay"
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ border: 'none' }}
              ></iframe>
            </div>
            <div className="text-center">
              <motion.a
                whileHover={{ scale: 1.05 }}
                href="https://drive.google.com/file/d/11w-tczJAf8ntcm4BQwQoYinCng0R7EFF/view"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-navy-600 text-white px-6 py-3 rounded-full text-lg font-semibold hover:bg-navy-700 transition-colors"
              >
                Open in Google Drive
                <ExternalLink className="w-5 h-5" />
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
